var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserType = function SvgUserType(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.75 19c.21-2.102 1.876-3.75 4.25-3.75s4.04 1.648 4.25 3.75M17.5 8.25h.5m-3.5 2.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m3.75-2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m-12.5 11h12.5a3 3 0 0 0 3-3v-8.5a3 3 0 0 0-3-3H5.75a3 3 0 0 0-3 3v8.5a3 3 0 0 0 3 3"
  })));
};
export default SvgUserType;